import type { ButtonProps } from '@/app/components/button';
import type { ImageProps } from '@/app/components/media/image/types';
import { MY_ISUZU_APP_STORE_URLS } from '@/app/constants/short-io';
import { MY_ISUZU_APPOINTMENT } from '@/app/lcv/contents/service/service-shared.data';

type ImagePropsType = Omit<ImageProps, 'aspectRatio'>;
export interface DealerHomeData {
  coverImage: {
    image: ImagePropsType;
    imageDesktop: ImagePropsType;
  };
}

export interface StoreAppProps {
  qrcode?: {
    url: string;
    image?: ImagePropsType;
  };
  ios?: {
    url: string;
    image?: ImagePropsType;
  };
  android?: {
    url: string;
    image?: ImagePropsType;
  };
}

export interface DealerPopupData {
  isActive: boolean;
  description: string;
  logo?: ImagePropsType;
  coverImage: ImagePropsType;
  button: ButtonProps;
  storeApp?: StoreAppProps;
}

export const DEALER_PLACEHOLDER_SEARCH = 'ค้นหาจังหวัด, เขต หรือ เลขไปรษณีย์';

export const DEALER_HOME_DATA: DealerHomeData = {
  coverImage: {
    image: {
      src: 'https://assets.isuzu-tis.com/service_center_5c7fb70dc2.jpg',
      alt: 'Service Center',
      width: 1080,
      height: 608,
    },
    imageDesktop: {
      src: 'https://assets.isuzu-tis.com/service_center_desktop_7b9bbc5713.jpg',
      alt: 'Service Center',
      width: 1080,
      height: 1440,
    },
  },
};

export const DEALER_POPUP_DATA: DealerPopupData = {
  isActive: false,
  description: `นัดหมายบริการ บน my-ISUZU App <br /><strong>ครั้งแรกรับส่วนลดสูงสุด 100 บาท</strong>`,
  button: {
    children: 'นัดหมายเลย',
    href: MY_ISUZU_APPOINTMENT,
    target: '_blank',
  },
  logo: {
    src: 'https://assets.isuzu-tis.com/logo_5747c52ad2.svg',
    alt: 'My Isuzu',
    width: 160,
    height: 20,
  },
  coverImage: {
    src: 'https://assets.isuzu-tis.com/cover_image_c154f9ea8a.jpg',
    alt: 'Ads',
    width: 328,
    height: 185,
  },
  storeApp: {
    qrcode: {
      url: MY_ISUZU_APP_STORE_URLS.GENERAL,
      image: {
        src: 'https://assets.isuzu-tis.com/qr_code_55747b7a3b.png',
        alt: 'QR Code my-ISUZU',
        width: 96,
        height: 96,
      },
    },
    ios: {
      url: MY_ISUZU_APP_STORE_URLS.IOS,
      image: {
        src: 'https://assets.isuzu-tis.com/app_store_8f0c12c555.svg',
        alt: 'Download on the App Store',
        width: 174,
        height: 64,
      },
    },
    android: {
      url: MY_ISUZU_APP_STORE_URLS.ANDROID,
      image: {
        src: 'https://assets.isuzu-tis.com/google_play_c37088729a.svg',
        alt: 'Get it On Google Play',
        width: 174,
        height: 64,
      },
    },
  },
};
